module.exports = __webpack_public_path__ + "img/history-six.62dc9842.png";